import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Form from '../../../../../components/Form/Form';
import { currencyFormate } from "../../../../../components/Date_Formate_Utilitiy/Index";
import { groupListCreate, groupSingle, groupUpdate, ledgerUpdate, ledgerSingleData, openModal, closeModal } from '../../../../../redux/actions/action-creator';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import { toast } from 'react-toastify';


const LedgerView = ({ data_to_view, title, closeModal_sec }) => {
  const dispatch = useDispatch();

  const [load, setLoad] = useState(false)
  // get redux state -----------------------------------------------------
  const group_all_list = useSelector(state => state.common.group_all_list);
  const { userData = null } = useSelector(state => state.auth);
  const modal_state = useSelector(state => state.common.modal_state);
  const str = '\u2666';
  const initialState = {
    company_id: userData?.id,
    account_no: '',
    ledger_name: '',
    alise_name: '',
    group_id: userData?.group_data[1]?.id,
    under_id: userData?.group_data[1]?.name,

    maintain_balance_bill_by_bill: 'No',//done
    default_credit_period: '',//done
    specify_credit_limit: '',//done
    inventory_values_are_affected: 'No',//done
    type_of_ledger: 'Not Applicable',//done
    rounding_method: '',//done
    rounding_limit: '',//done

    effective_date_for_reconciliation: '',//done
    set_od_limit: '',//done
    ac_holders_name: '',//done
    ac_no: '',//done
    ifs_code: '',//done
    swift_code: '',//done
    bank_name: 'Not Applicable',//done
    branch: '',//done
    set_alter_range_for_checque_books: 'No',//done
    enable_check_printing: 'No',//done
    set_alter_cheque_printing_configuration: 'No',//done
    use_as_notional_bank_for_post_dated_vouchers: 'No',//done

    behave_as_duties_and_taxes_ledger: '',//no
    type_of_duty_tax: '',//no
    tax_type: '',//no
    valuation_type: '',//done
    rate_per_unit: '',//done
    percentage_of_calculation: '',//done
    gst_applicability: 'Not Applicable',//done
    set_alter_gst_details: '',//no
    include_in_assessable_value_calculation: 'Not Applicable',//done
    hsn_sac_details: '',//done
    source_of_details: '',//done
    hsn_sac: '',//done
    description: '',//done
    gst_rate_details: '',//done
    taxability_type: '',//done
    nature_of_transaction: '',//dpne
    igst_rate: '',//done
    cgst_rate: '',//done
    sgst_utgst_rate: '',//done
    cess_valution_type: '',//done
    cess_rate: '',//done
    applicable_for_reverse_charge: '',//done
    eligible_for_input_tax_credit: '',//done
    type_of_supply: '',//done
    check_for_credit_days_duriing_voucher_entry: '',//done
    method_of_appropriation_to_allocate_additional_consts_in_purchas: 'Not Applicable',//done

    mailing_name: '',//done
    address: '',//done
    city: '',
    state: 'Madhya Pradesh',//done
    country: 'India',//done
    pincode: '',//done
    mobile_no: '',//done
    email: '',//done
    provide_contact_details: 'No',//done
    provide_bank_details: 'No',//done
    pan_it_no: '',//done
    aadhaar: '',//aadhar
    transport_detail: '',//done

    registration_type: '',//done
    assessee_of_other_territory: '',//done
    gst_in_uin: '',//done
    use_ledger_as_common_party: '',//done
    set_alter_additional_gst_details: '',//done
    ignore_prefixes_and_suffixes_in_doc_no_for_reconciliation: '',//done

    opening_balance: '',//done
    type: '',//done

    override_credit_limit_using_post_dated_transaction: '',
    appropriate_to: '',
    method_of_calculation: '',
    classification: '',

    group_slug: userData?.group_data[1]?.group_slug,
    nature_of_group: userData?.group_data[1]?.nature_of_group,
    id: data_to_view?.id
  }
  const [data, setData] = useState(initialState);

  useEffect(() => {
    setLoad(true);
    const formData = new FormData();
    formData.append('id', data_to_view?.id);
    formData.append('company_id', userData?.id);
    dispatch(ledgerSingleData(formData)).then((response) => {
      if (response?.status) {
        setData({
          company_id: userData?.id,
          id: data_to_view?.id,
          account_no: response.data.account_no,
          ledger_name: response.data.ledger_name,
          alise_name: response.data.alias_name,
          group_id: response.data.group_id,
          under_id: response.data.group_name,

          maintain_balance_bill_by_bill: response.data.maintain_balance_bill_by_bill,
          default_credit_period: response.data.default_credit_period,
          specify_credit_limit: response.data.specify_credit_limit,
          inventory_values_are_affected: response.data.inventory_values_are_affected,
          type_of_ledger: response?.data?.type_of_ledger,
          rounding_method: response.data.rounding_method,
          rounding_limit: response.data.rounding_limit,

          effective_date_for_reconciliation: response.data.effective_date_for_reconciliation,
          set_od_limit: response.data.set_od_limit,
          ac_holders_name: response.data.ac_holders_name,
          ac_no: response.data.ac_no,
          ifs_code: response.data.ifs_code,
          swift_code: response.data.swift_code,
          bank_name: response.data.bank_name,
          branch: response.data.branch,
          set_alter_range_for_checque_books: response.data.set_alter_range_for_checque_books,
          enable_check_printing: response.data.enable_check_printing,
          set_alter_cheque_printing_configuration: response.data.set_alter_cheque_printing_configuration,
          use_as_notional_bank_for_post_dated_vouchers: response.data.use_as_notional_bank_for_post_dated_vouchers,

          behave_as_duties_and_taxes_ledger: '',
          type_of_duty_tax: '',
          tax_type: '',
          valuation_type: response.data.valuation_type,
          rate_per_unit: response.data.rate_per_unit,
          percentage_of_calculation: response.data.percentage_of_calculation,
          gst_applicability: response?.data?.gst_applicability,
          set_alter_gst_details: response.data.set_alter_additional_gst_details,
          include_in_assessable_value_calculation: response?.data?.include_in_assessable_value_calculation,
          hsn_sac_details: response.data.hsn_sac_details,
          source_of_details: response.data.source_of_details,
          hsn_sac: response.data.hsn_sac,
          description: response.data.description,
          gst_rate_details: response.data.gst_rate_details,
          taxability_type: response.data.taxability_type,
          nature_of_transaction: response.data.nature_of_transaction,
          igst_rate: response.data.igst_rate,
          cgst_rate: response.data.cgst_rate,
          sgst_utgst_rate: response.data.sgst_utgst_rate,
          cess_valution_type: response.data.cess_valution_type,
          cess_rate: response.data.cess_rate,
          applicable_for_reverse_charge: response.data.applicable_for_reverse_charge,
          eligible_for_input_tax_credit: response.data.eligible_for_input_tax_credit,
          type_of_supply: response.data.type_of_supply,
          check_for_credit_days_duriing_voucher_entry: response.data.check_for_credit_days_duriing_voucher_entry,
          method_of_appropriation_to_allocate_additional_consts_in_purchas: response?.data?.method_of_appropriation_to_allocate_additional_consts_in_purchas,

          mailing_name: response.data.mailing_name,
          address: response.data.address,
          city: response.data.city,
          state: response.data.state,
          country: response?.data?.country,
          pincode: response.data.pincode,
          mobile_no: response.data.mobile_no,
          email: response.data.email,
          provide_contact_details: response.data.provide_contact_details,
          provide_bank_details: response.data.provide_bank_details,
          pan_it_no: response.data.pan_it_no,
          aadhaar: response.data.aadhaar,
          transport_detail: response.data.transport_detail,

          registration_type: response.data.registration_type,
          assessee_of_other_territory: response.data.assessee_of_other_territory,
          gst_in_uin: response.data.gst_in_uin,
          use_ledger_as_common_party: response.data.use_ledger_as_common_party,
          set_alter_additional_gst_details: response.data.set_alter_additional_gst_details,
          ignore_prefixes_and_suffixes_in_doc_no_for_reconciliation: response.data.ignore_prefixes_and_suffixes_in_doc_no_for_reconciliation,

          override_credit_limit_using_post_dated_transaction: '',
          appropriate_to: '',
          method_of_calculation: '',
          classification: '',

          group_slug: response?.data?.group_slug,
          nature_of_group: response?.data?.nature_of_group,

          opening_balance: response.data.opening_balance,
          opening_amt: response.data.opening_amt,
          type: response.data.type

        })

        setLoad(false)
      }
      else {
        toast.warn(response?.message || 'Fail !', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }).catch(error => {
      toast.error(error?.message || ' Failed!', {
        position: toast.POSITION.TOP_CENTER
      });
    })
  }, [])
  return (
    <Form
      title='Ledger View'
      loading={load}
      col='col-7'
      Footer={MasterListFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Name
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.ledger_name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Alise
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.alise_name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Account Number
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.account_no}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Group Name
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.under_id}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Nature Of Group
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.nature_of_group}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Address
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.address}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          City
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.city}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Mobile No.
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.mobile_no}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Aadhaar
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.aadhaar}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Opening Balance
        </div>
        <div
          className="col-1 font_size p-0 m-0 text-center fw-bold"
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {currencyFormate(Number(data?.opening_amt || 0).toFixed(2))} {data?.type}
        </div>
      </div>
    </Form>
  )
}
export default React.memo(LedgerView);